import { uuid } from './../../util/index'

export default {
    document_db_id: null,
    document_url_id: null,
    entity_id: null,
    name: 'First planner board.',
    description: 'My first project',
    entity_name: 'Planner',
    entity_group: 'Planner',
    columns: [],
    team_id: null,
    team_shared: false,
}
